<div class="dialog">

  <div class="form-row">

    <mat-form-field appearance="outline" style="width:25%; margin-left:5%">
      <mat-label>Commission Voucher Amount</mat-label>
      <input matInput type="number" [(ngModel)]="crdtvAmt" readonly>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width:25%; margin-left:2%">
      <mat-label>Select Entry Amount</mat-label>
      <input matInput type="number" [(ngModel)]="selectedAmt" readonly>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width:25%; margin-left:2%">
      <mat-label>Balance Amount</mat-label>
      <input matInput type="number" [(ngModel)]="balanceAmt" readonly>
    </mat-form-field>

  </div>

  <table class="table table-bordered border-primary">

    <thead>
      <tr>
        <th>Sr. No.</th>
        <th>Book Name</th>
        <th>Net Amount</th>
        <th>Book Copies</th>
        <th>Total</th>
        <th>Shipping Charges</th>
        <th>Total Value</th>
        <th>Inv Received Amount</th>
        <th>Book Comm Value</th>
        <th>Book Comm %</th>
        <th>Already Received</th>
        <th>Received Amount</th>
        <th>Remaining Amount</th>
      </tr>
    </thead>

    <tbody>

      <tr *ngFor="let book of bookCommdata; let i=index">

        <td>{{i+1}}</td>
        <td>{{book.book_name}}</td>
        <td>{{book.book_price}}</td>
        <td>{{book.book_copies}}</td>
        <td>{{book.total}}</td>
        <td>{{book.shipping_charges}}</td>
        <td>{{book.total_amount}}</td>
        <td>{{book.inv_received_amt}}</td>
        <td>{{book.rep_commission_amt}}</td>

        <td>
          <input type="number"
                 style="width:70px"
                 [value]="book.commper"
                 (change)="calcCommission(book,$event)">
        </td>

        <td>{{book.comm_rcvd_amt}}</td>

        <td>
          <mat-form-field appearance="outline" style="width:80px">
            <input matInput
                   type="number"
                   [value]="book.rcvd_amt"
                   (change)="calcamount($event,book)"
                   [disabled]="book.isDisabled">
          </mat-form-field>
        </td>

        <td>{{book.comm_remaining_amt}}</td>

      </tr>

      <tr>

        <td colspan="10"></td>

        <td><b>{{total_val}}</b></td>
        <td></td>
        <td><b>{{total_remaining_amt}}</b></td>

      </tr>

    </tbody>

  </table>

</div>

<div class="dialog">

  <button class="btn btn-primary"
          style="margin-top:2%; width:10%"
          (click)="save()">
    Update
  </button>

</div>